/* Calm, single column, no bubbles: a working sheet beside the song (chat makeover, "Direction") */
.thread {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2, 16px);
  padding: var(--tuna-spacing-1_5, 12px);
  font-size: var(--tuna-typography-fontSize-md);
  line-height: 1.5;
  color: var(--tuna-content-primary);
}

.exchange {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1, 8px);
}

.anchorRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-1, 8px);
}

/* The section's colour as a short bar at the chip's start, like the section block's line; text stays secondary */
.anchorChip {
  padding: 0 var(--tuna-spacing-1, 8px);
  box-shadow: inset 3px 0 0 var(--section-color, transparent);
  font-size: var(--tuna-typography-fontSize-sm);
  color: var(--tuna-content-secondary);
  background: var(--tuna-palette-action-hover);
  border-radius: var(--tuna-shape-radius-pill);
}

.gone,
.question,
.decided {
  margin: 0;
  color: var(--tuna-content-secondary);
}

.answer,
.comment {
  overflow-wrap: anywhere;
}

.proposal {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-0_5, 4px);
  padding: var(--tuna-spacing-1, 8px);
  border: 1px solid var(--tuna-palette-divider, rgba(0, 0, 0, 0.12));
  border-radius: var(--tuna-shape-radius-md);
}

.actions {
  display: flex;
  gap: var(--tuna-spacing-1, 8px);
}

.error {
  color: var(--tuna-palette-error-main);
}

/* Touch: 44px targets */
@media (pointer: coarse) {
  .actions > *,
  .anchorRow > button {
    min-height: 44px;
  }
}

/* The panel's empty state, while the thread has nothing in it (Joni, #3070) */
.empty {
  padding: var(--tuna-spacing-2);
  color: var(--tuna-content-secondary);
}
